// extracted by mini-css-extract-plugin
module.exports = {"getConfigLoader":"getConfig_getConfigLoader__1dNO-"};